module.exports = __webpack_public_path__ + "img/pgn05.f69af126.png";